import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/date-fns/esm/addDays/index.js';

var require$$8 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$8 as default };
